require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2012-02-22-designing-network-protocols.json") })
        }
      }, "path---articles-2012-02-22-designing-network-protocols");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2012-02-22-designing-network-protocols!./.cache/json/articles-2012-02-22-designing-network-protocols.json
// module id = 617
// module chunks = 231608221292675